<template>
  <div>
    <header class="container-fluid bg-white d-flex  py-1" style="width: 100vw; z-index: 2; position: absolute;">
      <div  class="d-flex align-items-center container" style="position: relative; z-index: 2;">
        <img :src="images.logo" class="me-2">
      </div>
    </header>    
    <div class="content container d-flex justify-content-center align-items-center vh-100">
      <video playsinline autoplay muted loop style="object-fit: cover; width: 100vw; height: 100vh; position: fixed; top: 0; left: 0; z-index: -1;">
        <source  :src="videoSources" type="video/mp4" />
      </video>
      <div class="text-center" id="middleman">
        <div class="imgsec d-flex justify-content-center align-items-center mb-4">
          <img :src="images.sectionOneImg1"  style="min-width:125px; width: 123px; max-height: 100px;"/>
          <img :src="images.sectionOneImg2" class="img-fluid"/>
        </div>
        <button type="button" style="border-radius: 2px" class="btn btn-primary me-3" @click="navigateToSecond">Download Document</button>
        <button type="button" style="border-radius: 2px" class="btn btn-secondary me-3" @click="navigateToSecond">View Document</button>
        <div class="imgsec d-flex justify-content-center align-items-center mt-4">
          <img :src="images.sectionTwo" class="img-fluid" alt="Footer Image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";

export default {
  setup(props, { emit }) {
    const emery = ref("");

    onMounted(() => {
      const params = new URLSearchParams(window.location.search);
      emery.value = params.get("e") || "";
    });

    const navigateToSecond = () => {
      emit('navigate', {
        component: 'SecondView',
        query: emery.value
      });
    };

    return {
      images: {
        logo: "https://iili.io/JWGZ4SI.jpg",
        sectionOneImg1: ["https://iili.io/JWM95sn.png"], 
        sectionOneImg2: [ "https://iili.io/JWM98mB.png"],
        sectionTwo: "https://iili.io/JWM9veV.png",
      },
      // videoSources: ["https://i.imgur.com/itghkuI.mp4"],
      videoSources: require('@/assets/d.mp4'),
      navigateToSecond,
    };
  },
};
</script>

<style scoped>
  .content {position: relative;z-index: 1; }
  .imgsec{ flex-direction:column; }
</style>